/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAction, props } from '@ngrx/store';

import { IUser } from '../../models/index';

export const login = createAction('[Auth] Login', props<{ email: string; password: string }>());

export const loginSuccess = createAction(
  '[Auth] Login Success',
  props<{ user: IUser; token: string }>()
);

export const loginFailure = createAction(
  '[Auth] Login Failure',
  props<{ error: string }>() // Cambiado 'any' a 'string' para el error por simplicidad inicial
);

export const logout = createAction('[Auth] Logout');

export const logoutSuccess = createAction('[Auth] Logout Success');
export const logoutFailure = createAction('[Auth] Logout Failure', props<{ error: any }>());

// Actions for Auto-Login / Initialization
export const tryAutoLogin = createAction('[Auth] Try Auto Login');
export const autoLoginSuccess = createAction(
  '[Auth] Auto Login Success',
  props<{ user: IUser; token: string }>()
);
export const autoLoginFailure = createAction('[Auth] Auto Login Failure');

// Password Reset Actions
export const requestPasswordReset = createAction(
  '[Auth] Request Password Reset',
  props<{ email: string }>()
);

export const passwordResetSuccess = createAction('[Auth] Password Reset Success');

export const passwordResetFailure = createAction(
  '[Auth] Password Reset Failure',
  props<{ error: string }>()
);

// Acciones para recuperar la contraseña (recover password)
export const recoverPassword = createAction(
  '[Auth] Recover Password',
  props<{ newPassword: string; token: string }>()
);

export const recoverPasswordSuccess = createAction(
  '[Auth] Recover Password Success',
  props<{ token: string; user: IUser }>()
);

export const recoverPasswordFailure = createAction(
  '[Auth] Recover Password Failure',
  props<{ error: string }>()
);

// Podríamos añadir una acción para limpiar errores si es necesario, por ejemplo:
// export const clearAuthError = createAction('[Auth] Clear Error');
